import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    FormHelperText
} from '@material-ui/core';

import {
} from './';

import {
    UploadFile
} from '../../../common';

import { PageContext } from '../PageContext';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    notShow: {
        display: "none"
    }
}));

export const ImportDialog = ({
    open,
    disabled,
    upload,
    onClose,
    onFileUploaded,
    handleChange,
    value,
    ...props }) => {
    const classes = useStyles();

    const [showWarning, setShowWarning] = useState(false);

    const [showModal, setShowModal] = useState(false);

    return (
        <Dialog
            aria-labelledby="table-content-import"
            open={open}
            onClose={onClose} 
            className={ !showModal ? "" : classes.notShow }
            >
            <DialogTitle id="table-content-import">
                Import table rows from Excel
            </DialogTitle>
            <DialogContent>
                <FormControl>
                    <FormLabel>Import type</FormLabel>
                    <RadioGroup
                        row
                        name="row-radio-buttons-group"
                        defaultValue={"append"}
                        onChange={event => {
                            event.persist();
                            var clearOnImport = event.target.value === "append" ? false : true;
                            handleChange(clearOnImport);
                            setShowWarning(clearOnImport);
                        }}>
                        <FormControlLabel value={"append"} control={<Radio />} label="APPEND" />
                        <FormControlLabel value={"clear"} control={<Radio />} label="CLEAR" />
                    </RadioGroup>
                    {/* {showWarning ? <FormHelperText>  WARNING: Import type CLEAR will delete all the table content.</FormHelperText> : null} */}
                </FormControl>
                <UploadFile
                    singleFile
                    title="Drop here an .xls or an .xlsx file or a .zip file"
                    disabled={disabled}
                    upload={upload}
                    onFileUploaded={onFileUploaded}
                    showWarning={ showWarning }
                    setShowModal={ setShowModal }
                    showModal={ showModal }
                />
                <br />
                <Typography variant="caption">
                    Upload either an .xls or an .xlsx file or a .zip file containing a single file.<br /><br />
                    The excel file must contain the same structure of the target table in which you want to import rows.
                    This means that the file should have the same number and the same order of the columns that are present in the table.
                    In the first row of the excel file you must have the names of the columns that are present in the table.
                </Typography>
                <br /><br />
            </DialogContent>
        </Dialog>
    );
}